import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { IReportCompanies } from "../../models"
import { act } from "react-dom/test-utils"

interface ReportCompaniesState {
    reportCompanies?: IReportCompanies[],
    idJsonFile?: string,
    reportCompaniesTotal: number,
    reportCompaniesPagination : {
        page: number,
        limit: number
    }
}

const initialState: ReportCompaniesState = {
    reportCompanies: undefined,
    reportCompaniesTotal: 0,
    reportCompaniesPagination: {
        page: 1,
        limit: 500
    }
}

export const reportCompaniesSlice = createSlice({
    name: 'reportCompanies',
    initialState,
    reducers: {
        setReportCompaniesState(state, action: PayloadAction<{reportCompanies: IReportCompanies[], idJsonFile: string, total: number}>){
            state.reportCompanies = action.payload.reportCompanies;
            state.reportCompaniesTotal = action.payload.total
            state.idJsonFile = action.payload.idJsonFile;
        },

        resetReportCompaniesState( state, action: PayloadAction<{reportCompanies: IReportCompanies[], idJsonFile: string, total: number}>){
            state.reportCompanies = initialState.reportCompanies
        },
        setReportCompaniesPaginationState(state, action: PayloadAction<{page: number, limit: number }>){
            state.reportCompaniesPagination = {
                page: action.payload.page,
                limit: action.payload.limit
            }
        },

        setReportCompaniesTotalState(state, action: PayloadAction<{total: number}>){
            state.reportCompaniesTotal = action.payload.total
        }
    }
})

export const { 
    setReportCompaniesState,
    setReportCompaniesPaginationState,
    setReportCompaniesTotalState,
    resetReportCompaniesState
} = reportCompaniesSlice.actions;
export const reportCompaniesReducer = reportCompaniesSlice.reducer;